export default "__VITE_ASSET__DljiBsgq__"